export default "__VITE_ASSET__3b7516c9__"